import AuthMixin from '@/components/mixins/auth-mixin'
import Draggable from 'vuedraggable'
import UserDbMenu from './smart-text-menu/smart-text-menu-tmpl'
import SmartTextTagsSlider from './smart-text-tags-slider/smart-text-tags-slider-tmpl'
import MediaScheduleMixin from '@/components/mixins/media-schedule-mixin'
import { mapGetters } from 'vuex'

const SMART_TEXT_CLIPBOARD_EL_ID = 'smartTextClipboard'

export default {
  name: 'userDatabase',
  inject: [
    '$utils',
    '$api',
    '$apiError'
  ],
  components: {
    Draggable,
    UserDbMenu,
    SmartTextTagsSlider
  },
  props: {
    routeNameProp: {
      type: String,
      default () { return '' }
    }
  },
  watch: {
    routeNameProp (newVal) {
      this.routeName = newVal
      this.setDefaultData()
    },
    '$route.params' (newVal, prevVal) {
      this.setDefaultData()
    }
  },
  mixins: [AuthMixin, MediaScheduleMixin],
  data () {
    return {
      userDbDataBeforeSortMoved: [],
      error: '',
      userDbListOrig: [],
      userDbList: [],
      selectedUserDbId: null,
      selectedUserDbDetails: null,
      selectedCell: {
        column: null,
        row: null
      },
      rowItemSortDragTriggered: false,
      userDbActionOptions: {
        copy: 'copy',
        delete: 'delete',
        entireRowClicked: 'entireRowClicked',
        selectedUserDbEntireRowClick: 'selectedUserDbEntireRowClick',
        selectedUserDbRowCellClick: 'selectedUserDbRowCellClick',
        selectedUserDbCopyRow: 'selectedUserDbCopyRow',
        selectedUserDbDeleteRow: 'selectedUserDbDeleteRow',
        rowVisible: 'rowVisible'
      },
      hoverAllDeleteIcon: false,
      selectedUserDbRow: null,
      tagsSummary: [],
      defaultNumberOfColumns: 0,
      enableUserDbActions: false,
      isCtrlKeyPressed: false
    }
  },
  methods: {
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('user-db-change', { action, payload: { data } })
      }
    },
    setDefaultData () {
      const selectedSmartTextId = this.$route.params && this.$route.params.smartTextId

      this.selectedUserDbDetails = null
      this.selectedUserDbRow = null
      this.selectedUserDbId = null
      this.selectedCell = { column: null, row: null }

      if (!selectedSmartTextId) {
        this.getUserDbList()
      }

      if (selectedSmartTextId) {
        this.selectedUserDbId = selectedSmartTextId
        this.getUserDbDetails({ id: selectedSmartTextId })
      }
    },
    notColumnNameKeys () {
      return ['_edit', 'order', 'uid', '_isNew', 'width', 'visible']
    },
    filterSelectedUserDbDetails (params) {
      const userDbDetails = this.$utils.clone(params.userDbDetails)
      const leftOffset = this.$utils.is1280View() ? 110 : 145
      const rowElWrapperWidth = $('.el-main').width() - leftOffset
      let totalPredefinedColumnWidth = 0 // by percent
      let hideColumnsSettings = false

      // Add a flag to hide column choice settings if columns is present or empty
      if (!userDbDetails.columns) {
        userDbDetails.columns = []
      } else if (userDbDetails.columns && userDbDetails.columns.length > 0) {
        hideColumnsSettings = true
      }

      // Total width of predefined column
      userDbDetails.columns.forEach((col) => {
        if (col.width) totalPredefinedColumnWidth += parseInt(col.width)
      })

      if (!userDbDetails._edit) {
        userDbDetails._edit = {
          uid: this.$utils.generateUniqueID(),
          selected: true,
          backgroundColor: '#b4c7db',
          data: userDbDetails.data
        }
      }

      userDbDetails._edit.hideColumnsSettings = hideColumnsSettings

      // Data should not have null value
      userDbDetails.data = userDbDetails.data.map((item, indx) => {
        for (const i in item) if (item[i] === null) item[i] = ''
        return item
      })

      const userDbDetailsData = userDbDetails._edit.data
      for (const indx in userDbDetailsData) {
        const row = userDbDetailsData[indx]
        let elColumnsWidth = rowElWrapperWidth

        if (!row.order) {
          const topSiblingDetails = (userDbDetailsData[indx - 1]) ? userDbDetailsData[indx - 1] : false
          const bottomSiblingDetails = (userDbDetailsData[indx + 1]) ? userDbDetailsData[indx + 1] : false
          const topSiblingOrder = topSiblingDetails ? topSiblingDetails.order : false
          const bottomSiblingOrder = bottomSiblingDetails ? bottomSiblingDetails.order : false
          row.order = this.$utils.calculateSortOrderValue({ topSiblingOrder, bottomSiblingOrder, previousOrderVal: 0 })
        }

        if (!row._edit) {
          row._edit = {
            isRowSelected: false,
            backgroundColor: '#b4c7db',
            visible: true
          }
        }

        row._edit.sortKeyWithIndx = `${row.order}_${indx}`

        if (!row.visible) {
          row._edit.visible = false
        }

        row._edit.isRowSelected = false
        if (this.selectedUserDbRow && (this.selectedUserDbRow.uid === row.uid)) {
          row._edit.isRowSelected = true
        }

        row._edit.columns = {}

        /**
         * Map column data in predifined columns
         * - Map column names from columns and follow the position
         * - Filter column name to remove property used by ui
         * - If there's given width from columns then calculate using percentage
         */
        const filteredColumns = this.$utils.clone(row)
        const removeKey = this.notColumnNameKeys()
        for (const rPropIndx in filteredColumns) {
          if (removeKey.indexOf(rPropIndx) >= 0) delete filteredColumns[rPropIndx]
        }

        // Column content depends on the predifined columns
        if (userDbDetails.columns && userDbDetails.columns.length) {
          for (const predefinedColumnIndx in userDbDetails.columns) {
            const predifinedProp = userDbDetails.columns[predefinedColumnIndx]
            let columnName = `column${predefinedColumnIndx}`

            if (predifinedProp && predifinedProp.name) {
              columnName = predifinedProp.name
            }

            if (!(columnName in filteredColumns)) {
              filteredColumns[columnName] = ''
            }
          }
        }

        for (const columnName in filteredColumns) {
          const columnWithDetails = {
            columnName,
            title: '',
            value: filteredColumns[columnName],
            width: 0,
            maxInputValue: null,
            redText: false,
            index: columnName.includes('column') ? parseInt(columnName.substr(6)) : null,
            definedWidthInColumns: null,
            type: 'text'
          }

          // Find from columns
          userDbDetails.columns.forEach((col, position) => {
            // Check if column name match
            if (col.name && col.name === columnName) {
              columnWithDetails.index = position

              if (col.type) {
                columnWithDetails.type = col.type
              }

              if (col.width) {
                columnWithDetails.width = parseInt(col.width.replace('%', ''))
                columnWithDetails.definedWidthInColumns = col.width
              }

              if (col.max) {
                columnWithDetails.maxInputValue = parseInt(col.max)
                columnWithDetails.redText = columnWithDetails.value.length > columnWithDetails.maxInputValue
              }
            }

            // Check if index match and type
            if ((!col.name && columnWithDetails.index === position) && col.type) {
              columnWithDetails.type = col.type
            }

            // Check if index match and width
            if ((!col.name && columnWithDetails.index === position) && col.width) {
              columnWithDetails.width = parseInt(col.width.replace('%', ''))
              columnWithDetails.definedWidthInColumns = col.width
            }

            // Check if index match and max
            if ((!col.name && columnWithDetails.index === position) && col.max) {
              columnWithDetails.maxInputValue = parseInt(col.max)
              columnWithDetails.redText = columnWithDetails.value.length > columnWithDetails.maxInputValue
            }
          })

          // Create Title
          if (columnWithDetails.type === 'schedule') {
            columnWithDetails.title = this.createScheduleTimeTitle(filteredColumns[columnName], { timeFormat: this.timeFormat }).range
          } else {
            columnWithDetails.title = String(filteredColumns[columnName])
          }

          // Calculate width from wrapper
          if (columnWithDetails.width !== 0) {
            const getWidthFromWrapper = (elColumnsWidth * (columnWithDetails.width / 100))
            columnWithDetails.width = `${getWidthFromWrapper}px`
            elColumnsWidth = (elColumnsWidth - getWidthFromWrapper)
          }

          row._edit.columns[`${columnWithDetails.index}`] = columnWithDetails
        }

        // Set columns width that are not set in columns
        const countNewColumns = () => {
          const r = { all: 0, withWidthZero: 0, totalWidth: 0 }
          for (const rIndx in row._edit.columns) {
            if (row._edit.columns[rIndx].width === 0) {
              r.withWidthZero += 1
            }
            r.all += 1
          }
          return r
        }
        const widthForWidthZeroColumns = elColumnsWidth / countNewColumns().withWidthZero
        const widthForAllColumns = rowElWrapperWidth / countNewColumns().all

        for (const rIndx in row._edit.columns) {
          if (totalPredefinedColumnWidth < 100) {
            if (row._edit.columns[rIndx].width === 0) {
              row._edit.columns[rIndx].width = `${widthForWidthZeroColumns}px`
            }
          } else {
            row._edit.columns[rIndx].width = `${widthForAllColumns}px`
          }
        }
      }

      return userDbDetails
    },
    getUserDbDetails (params) {
      const apiRequest = () => {
        this.$utils.mainLoader(true)

        this.$api.get(`${CONFIG.API_BASE_URL}/userdb/${params.id}`)
          .then(response => {
            this.selectedUserDbDetails = this.filterSelectedUserDbDetails({ userDbDetails: response.data })
            this.defaultNumberOfColumns = this.countDbColumns(this.selectedUserDbDetails)

            this.$nextTick(_ => {
              this.$utils.updatePageComponentStyle({ name: 'userDbPageDefault' })
              this.focusTextareaForClipboard()
            })

            if (params.callback) {
              params.callback()
            } else {
              this.mainLoader(false)
            }
          })
          .catch((error) => {
            this.$utils.mainLoader(false)
            this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { apiRequest() } })
          })
      }
      apiRequest()
    },
    createTagsSummary () {
      const tags = []

      this.userDbListOrig.forEach((data) => {
        if (data.tags) {
          for (const i in data.tags) {
            if (tags.indexOf(data.tags[i]) < 0) {
              tags.push(data.tags[i])
            }
          }
        }
      })

      this.tagsSummary = tags
    },
    createUserDb () {
      const apiRequest = () => {
        this.$utils.mainLoader(true)
        const postPayload = {
          name: 'TICKETING INFO 1',
          tags: ['tag2'],
          data: [{ column1: 'test', column2: 'value' }, { column1: 'test2' }]
        }

        this.$api.post(`${CONFIG.API_BASE_URL}/userdb/`, postPayload)
          .then(response => {
            this.$utils.mainLoader(false)
          })
          .catch((error) => {
            this.$utils.mainLoader(false)
            this.$apiError.handleAPIRequestError(error, { originalRequest: () => { apiRequest() }, showDialogNotification: true })
          })
      }

      apiRequest()
    },
    filterUserDbList (userDbSrc) {
      const userDb = this.$utils.clone(userDbSrc)

      userDb.forEach((userDb, indx) => {
        if (!userDb._edit) {
          userDb._edit = {
            uid: this.$utils.generateUniqueID(),
            selected: false,
            backgroundColor: '#b4c7db'
          }
        }
      })

      return userDb
    },
    getUserDbList (params) {
      if (!params) params = {}

      const requestParams = {}
      const apiRequest = () => {
        this.$utils.mainLoader(true)
        this.$api.get(`${CONFIG.API_BASE_URL}/userdb/`, { params: requestParams })
          .then(response => {
            this.userDbListOrig = this.filterUserDbList(response.data)
            this.userDbList = this.userDbListOrig
            this.createTagsSummary()
            this.$utils.mainLoader(false)
            this.$utils.updatePageComponentStyle({ name: 'userDbPageDefault' })
          })
          .catch((error) => {
            this.error = error.message
            this.$utils.mainLoader(false)
            this.$apiError.handleAPIRequestError(error, { originalRequest: () => { apiRequest() }, showDialogNotification: true })
          })
      }
      apiRequest()
    },
    handleUserDbItemClick (action, item, indx, $event) {
      if (action === this.userDbActionOptions.entireRowClicked) {
        this.selectedUserDbId = item.id
        this.$router.push(`/smart-text/${item.id}`)
      }

      if (action === this.userDbActionOptions.copy) {
        const apiRequest = () => {
          this.$utils.mainLoader(true)
          this.$api.get(`${CONFIG.API_BASE_URL}/userdb/${item.id}`)
            .then(response => {
              const postPayload = response.data
              const createUserDbRequest = () => {
                this.$api.post(`${CONFIG.API_BASE_URL}/userdb/`, postPayload)
                  .then(response => {
                    this.getUserDbList()
                  })
                  .catch((error) => {
                    this.$utils.mainLoader(false)
                    this.$apiError.handleAPIRequestError(error, { originalRequest: () => { createUserDbRequest() }, showDialogNotification: true })
                  })
              }
              createUserDbRequest()
            })
            .catch((error) => {
              this.error = error.message
              this.$utils.mainLoader(false)
              this.$apiError.handleAPIRequestError(error, { originalRequest: () => { apiRequest() }, showDialogNotification: true })
            })
        }
        apiRequest()
      }

      if (action === this.userDbActionOptions.delete) {
        const apiRequest = () => {
          this.$utils.mainLoader(true)
          this.$api.delete(`${CONFIG.API_BASE_URL}/userdb/${item.id}`)
            .then(response => {
              this.getUserDbList()
            })
            .catch((error) => {
              this.error = error.message
              this.$utils.mainLoader(false)
              this.$apiError.handleAPIRequestError(error, { originalRequest: () => { apiRequest() }, showDialogNotification: true })
            })
        }
        apiRequest()
      }
    },
    handleRowItemSortStart () {
      this.rowItemSortDragTriggered = true
      this.userDbDataBeforeSortMoved = this.$utils.clone(this.selectedUserDbDetails._edit.data)
    },
    handleRowItemSortEnd (sortEvtVal) {
      this.rowItemSortDragTriggered = false
      // Previous Data
      const listBeforeSort = this.$utils.clone(this.userDbDataBeforeSortMoved)
      const previousIndexInList = sortEvtVal.oldIndex
      const previousOrderVal = listBeforeSort[previousIndexInList].order

      const selectedUserDbDetails = this.$utils.clone(this.selectedUserDbDetails)
      const selectedUserDbDetailsData = selectedUserDbDetails._edit.data
      const currentIndexInList = sortEvtVal.newIndex
      const topSiblingDetails = (selectedUserDbDetailsData[currentIndexInList - 1]) ? selectedUserDbDetailsData[currentIndexInList - 1] : false
      const bottomSiblingDetails = (selectedUserDbDetailsData[currentIndexInList + 1]) ? selectedUserDbDetailsData[currentIndexInList + 1] : false
      const topSiblingOrder = topSiblingDetails ? topSiblingDetails.order : false
      const bottomSiblingOrder = bottomSiblingDetails ? bottomSiblingDetails.order : false

      selectedUserDbDetailsData[currentIndexInList].order = this.$utils.calculateSortOrderValue({ topSiblingOrder, bottomSiblingOrder, previousOrderVal })

      this.selectedUserDbDetails = selectedUserDbDetails
    },
    countDbColumns (userDb) {
      let numberOfColumns = 0

      if (userDb.columns && userDb.columns.length > 0) {
        numberOfColumns = userDb.columns.length
      } else if (userDb._edit.data) {
        const firstRow = userDb._edit.data[0] // Get the first row length

        for (const key in firstRow) {
          if (this.notColumnNameKeys().indexOf(key) < 0) {
            numberOfColumns += 1
          }
        }
      }

      return numberOfColumns
    },
    getDefinedColumnProperty (dataIndex) {
      const res = { name: `column${dataIndex}`, width: null, type: 'text' }

      const userDbDetails = this.$utils.clone(this.selectedUserDbDetails)

      if (userDbDetails.columns && userDbDetails.columns.length) {
        for (let columnIndex = 0; columnIndex < userDbDetails.columns.length; columnIndex++) {
          const columnProps = userDbDetails.columns[columnIndex]

          if (columnIndex === dataIndex) {
            res.name = columnProps && columnProps.name ? columnProps.name : `column${dataIndex}`
            res.width = columnProps && columnProps.width ? columnProps.width : null
            res.type = columnProps && columnProps.type ? columnProps.type : null
          }
        }
      }

      return res
    },
    handleAddNewRow () {
      const selectedUserDbDetails = this.$utils.clone(this.selectedUserDbDetails)
      let newRow = { _isNew: true, uid: this.$utils.generateUniqueID() }
      let numberOfColumns = this.countDbColumns(selectedUserDbDetails)

      // If empty data then create row and column else just clone the last row and clear each column value
      if (!selectedUserDbDetails._edit.data.length) {
        // Get the number of column set from column choice menu
        if (this.$refs.userDbRowMenuForm && this.$refs.userDbRowMenuForm.$data.menuData.numOfColumns) {
          numberOfColumns = this.$refs.userDbRowMenuForm.$data.menuData.numOfColumns
        }

        // Set column number to 1 as default
        if (numberOfColumns <= 0 && !selectedUserDbDetails.data.length) {
          numberOfColumns = 1
          this.defaultNumberOfColumns = 1
        }

        if (numberOfColumns > 0) {
          const startColumnNumber = 0 // Should start column number name with 0 to match predifined columns indexing

          for (let i = startColumnNumber; i < numberOfColumns; i++) {
            const getColumnName = this.getDefinedColumnProperty(i).name
            newRow[getColumnName] = ''
          }
        }
      } else {
        const lastRow = this.$utils.clone(selectedUserDbDetails._edit.data[selectedUserDbDetails._edit.data.length - 1])
        newRow = { ...lastRow, ...newRow }

        // Clear value
        for (const columnName in newRow) {
          if (this.notColumnNameKeys().indexOf(columnName) < 0) newRow[columnName] = ''
        }
      }

      selectedUserDbDetails._edit.data.push(newRow)
      this.selectedUserDbRow = newRow
      this.selectedUserDbDetails = this.filterSelectedUserDbDetails({ userDbDetails: selectedUserDbDetails })
    },
    focusTextareaForClipboard () {
      const smartTextEl = document.getElementById(SMART_TEXT_CLIPBOARD_EL_ID)
      if (smartTextEl) smartTextEl.focus()
    },
    triggerAutoFocusTextareaForClipboard () {
      $(document).on('keydown', (e) => {
        if (e.ctrlKey || (e.key === 17 || e.which === 17)) {
          this.isCtrlKeyPressed = true
        }
      })

      $(document).on('mousemove', (e) => {
        if (!this.selectedUserDbRow) this.focusTextareaForClipboard()
      })

      $(document).on('click', (e) => {
        const targetEL = $(e.target)
        const targetElClassName = targetEL ? targetEL.attr('class') : ''
        const excludeClassname = ['cell-click-ref', 'el-input__inner']
        let triggerFocus = true

        excludeClassname.forEach((aClassname) => {
          if (targetElClassName && targetElClassName.includes(aClassname)) triggerFocus = false
        })

        if (triggerFocus) this.focusTextareaForClipboard()
      })
    },
    createTextareaForClipboard () {
      let smartTextEl = document.getElementById(SMART_TEXT_CLIPBOARD_EL_ID)

      if (!smartTextEl) {
        smartTextEl = document.createElement('textarea')
        smartTextEl.id = SMART_TEXT_CLIPBOARD_EL_ID
        Object.assign(smartTextEl.style, { opacity: 0, position: 'fixed', height: '0px', width: '0px', left: 0, top: 0, zIndex: 1, padding: '0px' })

        document.body.appendChild(smartTextEl)
        smartTextEl.focus()

        // Handle paste Event
        smartTextEl.addEventListener('paste', (event) => {
          if (!this.selectedUserDbDetails) return

          event.preventDefault()
          const text = (event.clipboardData || window.clipboardData).getData('text')
          const parsedString = text.split('\n').map((line) => line.split('\t'))
          let maxArrayLength = 0
          const newSmartTextRows = []

          // Get maximum number of columns from rows and row index
          parsedString.forEach((a, i) => {
            if (a.length > maxArrayLength) {
              maxArrayLength = a.length
            }
          })

          // All rows should have the same number of columns and all columns per row should not have an empty value
          parsedString.forEach((row) => {
            const newRow = row
            let addRow = 0
            if (row.length < maxArrayLength) addRow = (maxArrayLength - row.length)
            if (addRow > 0) {
              for (let i = 1; i <= addRow; i++) newRow.push('')
            }

            const isAllColumnsEmpty = row.every((column) => { return !column.trim().length })
            if (!isAllColumnsEmpty) newSmartTextRows.push(row)
          })

          // Add rows to the current list
          const selectedUserDbDetails = this.$utils.clone(this.selectedUserDbDetails)
          let getNumberOfColumns = this.countDbColumns(selectedUserDbDetails)
          const maxColumnSettings = 5
          const newSmartTextCountColumns = getNumberOfColumns > 0 ? getNumberOfColumns : maxArrayLength

          newSmartTextRows.forEach((row) => {
            const newRow = { _isNew: true, uid: this.$utils.generateUniqueID() }
            const selectedColumnCountInForm = row.length

            if (getNumberOfColumns < 1 && !selectedUserDbDetails._edit.data.length) {
              getNumberOfColumns = selectedColumnCountInForm
            }

            if (getNumberOfColumns > 0) {
              const startColumnNumber = 0 // Should start column number name with 0 to match predifined columns indexing
              for (let i = startColumnNumber; i < getNumberOfColumns; i++) {
                const getColumnName = this.getDefinedColumnProperty(i).name

                // Number of columns per row should match with the maximum value from settings
                if (i < maxColumnSettings) {
                  newRow[getColumnName] = row[i] ? row[i] : ''
                }
              }
            }

            selectedUserDbDetails._edit.data.push(newRow)
          })

          this.selectedUserDbDetails = this.filterSelectedUserDbDetails({ userDbDetails: selectedUserDbDetails })

          // Update selected number of columns in right side menu
          const userDbRowMenuNumberOfColumns = this.$refs.userDbRowMenuForm ? this.$refs.userDbRowMenuForm.$data.menuData.numOfColumns : 0
          if (userDbRowMenuNumberOfColumns < 1 || userDbRowMenuNumberOfColumns !== newSmartTextCountColumns) {
            this.defaultNumberOfColumns = newSmartTextCountColumns <= maxColumnSettings ? newSmartTextCountColumns : maxColumnSettings
          }
        })
      }
    },
    handleUserDbMenuChange ($event) {
      if ($event.action === 'NUMBER_OF_COLUMN_CHANGE') {
        const selectedUserDbDetails = this.$utils.clone(this.selectedUserDbDetails)
        const getNumberOfColumns = $event.payload.data
        this.selectedCell = { column: null, row: null }

        selectedUserDbDetails._edit.data.forEach((column, editDataIndx) => {
          const newRow = selectedUserDbDetails._edit.data[editDataIndx]

          // Clean up properties
          for (const key in newRow) {
            if (this.notColumnNameKeys().indexOf(key) < 0) {
              delete newRow[key]
            }
          }

          delete newRow._edit

          const startColumnNumber = 0 // Should start column number name with 0 to match predifined columns indexing
          for (let i = startColumnNumber; i < getNumberOfColumns; i++) {
            const getColumnName = this.getDefinedColumnProperty(i).name

            newRow[getColumnName] = ''

            // Get original value for data
            selectedUserDbDetails.data.forEach((column, dataIndx) => {
              for (const colName in column) {
                if ((colName === getColumnName) && (dataIndx === editDataIndx)) {
                  newRow[getColumnName] = column[colName]
                }
              }
            })
          }
        })

        this.selectedUserDbDetails = this.filterSelectedUserDbDetails({ userDbDetails: selectedUserDbDetails })
      }

      if ($event.action === 'PLAYTIME_FORM_UPDATED') {
        const userDbDetails = this.$utils.clone($event.payload.data.updatedUserDbDetails)
        this.selectedUserDbDetails = this.filterSelectedUserDbDetails({ userDbDetails })
      }

      if ($event.action === 'SUBMIT_BUTTON_CLICKED') {
        let newUserDbDetails = this.$utils.clone(this.selectedUserDbDetails)
        newUserDbDetails.data = newUserDbDetails._edit.data
        newUserDbDetails = this.cleanUpUserDbMainData(newUserDbDetails, { submitToBackend: true })

        const apiRequest = () => {
          this.$utils.mainLoader(true)
          this.$api.put(`${CONFIG.API_BASE_URL}/userdb/${newUserDbDetails.id}`, newUserDbDetails)
            .then(response => {
              this.selectedUserDbId = null
              this.selectedUserDbDetails = null
              this.selectedUserDbRow = null
              this.$router.push('/smart-text')
              this.$utils.mainLoader(false)
            })
            .catch((error) => {
              this.$utils.mainLoader(false)
              this.$apiError.handleAPIRequestError(error, { originalRequest: () => { apiRequest() }, showDialogNotification: true })
            })
        }
        apiRequest()
      }
    },
    cleanUpUserDbMainData (userDbDataSrc, params) {
      if (!params) params = {}

      const res = this.$utils.clone(userDbDataSrc)
      res.data = this.$utils.clone(res._edit.data)

      res.data.forEach((data, indx) => {
        if (data._edit) delete data._edit

        if (params.submitToBackend) {
          if (data.order) delete data.order
          if (data._isNew) delete data._isNew
          if (data.width) delete data.width
        }
      })

      if (res._edit) delete res._edit

      return res
    },
    handleTagsSliderChange ($event) {
      if ($event.action === 'TAGS_SELECTION') {
        if ($event.payload.data.value !== '_toSeeAllData') {
          const itemsToShow = []
          const userDbListOrig = this.$utils.clone(this.userDbListOrig)
          const selectedTags = [$event.payload.data.value]

          userDbListOrig.forEach((data) => {
            const includeTags = selectedTags.every((selectedTag) => { return data.tags.includes(selectedTag) })

            if (includeTags) {
              itemsToShow.push(data)
            }
          })

          this.userDbList = itemsToShow
        } else {
          this.userDbList = this.userDbListOrig

          if (this.selectedUserDbId) {
            this.selectedUserDbId = null
            this.selectedUserDbDetails = null
            this.$router.push('/smart-text')
          }
        }
      }
    },
    handleSelectedUserDbRowClick (action, userDbRow, indx, eventDom, column, columnIdex, params) {
      /* Select Entire Row */
      if (action === this.userDbActionOptions.selectedUserDbEntireRowClick) {
        this.selectedUserDbRow = { ...userDbRow, rowIndex: indx }
        this.selectedUserDbDetails = this.filterSelectedUserDbDetails({ userDbDetails: this.selectedUserDbDetails })
        this.selectedCell = { column, row: { ...userDbRow, rowIndex: indx } }

        if (params && (column.type !== 'schedule' && params.targetInput)) {
          this.$nextTick(_ => {
            this.$refs[params.targetInput][0].focus()
          })
        }
      }

      // Select Cell when row is selected
      if (action === this.userDbActionOptions.selectedUserDbRowCellClick) {
        this.selectedUserDbRow = { ...userDbRow, rowIndex: indx }
        this.selectedUserDbDetails = this.filterSelectedUserDbDetails({ userDbDetails: this.selectedUserDbDetails })
        this.selectedCell = { column, row: { ...userDbRow, rowIndex: indx } }
      }

      /* Duplicate Row */
      if (action === this.userDbActionOptions.selectedUserDbCopyRow) {
        const selectedUserDbDetails = this.$utils.clone(this.selectedUserDbDetails)
        const newRow = this.$utils.clone(userDbRow)
        delete newRow._edit

        // Create New Order
        const topSiblingDetails = (selectedUserDbDetails._edit.data[indx]) ? selectedUserDbDetails._edit.data[indx] : false
        const topSiblingOrder = topSiblingDetails ? topSiblingDetails.order : false
        const bottomSiblingOrder = false
        newRow.order = this.$utils.calculateSortOrderValue({ topSiblingOrder, bottomSiblingOrder, previousOrderVal: 0 })

        newRow.uid = this.$utils.generateUniqueID()
        selectedUserDbDetails._edit.data.push(newRow)
        this.selectedUserDbDetails = this.filterSelectedUserDbDetails({ userDbDetails: selectedUserDbDetails })
      }

      /* Delete Row */
      if (action === this.userDbActionOptions.selectedUserDbDeleteRow) {
        const newUserDbDetails = this.$utils.clone(this.selectedUserDbDetails)
        newUserDbDetails._edit.data = newUserDbDetails._edit.data.filter((data, i) => { return i !== indx })
        this.selectedUserDbDetails = newUserDbDetails
      }

      if (action === this.userDbActionOptions.rowVisible) {
        let newUserDbDetails = this.$utils.clone(this.selectedUserDbDetails)
        const newUserDbDetailsData = newUserDbDetails._edit.data
        const newUserDbRow = this.$utils.clone(userDbRow)

        if (newUserDbRow._edit.visible) {
          newUserDbDetailsData[indx].visible = false
        } else {
          newUserDbDetailsData[indx].visible = true
        }

        newUserDbDetails.data = newUserDbDetailsData

        newUserDbDetails = this.cleanUpUserDbMainData(newUserDbDetails)
        this.selectedUserDbDetails = this.filterSelectedUserDbDetails({ userDbDetails: newUserDbDetails })
      }
    },
    handleRowItemMouseHoverAndMouseOut (mouseEvent, item, domEvent) {
      if (domEvent.path && $(domEvent.path).hasClass('remove')) {
        if (mouseEvent === 'mouseover') {
          this.hoverAllDeleteIcon = true
        } else {
          this.hoverAllDeleteIcon = false
        }
      }
    },
    handleColumnInputTyping (column, columnIndex, columnName, editColumnValue, editColumnKey) {
      const newUserDbDetails = this.$utils.clone(this.selectedUserDbDetails)
      newUserDbDetails._edit.data[columnIndex][columnName] = editColumnValue
      this.selectedUserDbDetails = this.filterSelectedUserDbDetails({ userDbDetails: newUserDbDetails })
    },
    handleWhiteAreaClicked () {
      $(window).on('click', ($event) => {
        const rowContentEl = $('#userDbRowSortGroupWrapper')
        if (!rowContentEl.length) return

        const rowContentTop = rowContentEl.offset().top
        const rowContentLeft = rowContentEl.offset().left
        const rowContentEndRight = rowContentLeft + rowContentEl.width()
        const rowContentEndBottom = rowContentTop + rowContentEl.height()
        const xClickedPosition = $event.pageX
        const yClickedPosition = $event.pageY
        let clickedOutsideRowContent = false
        let clckedInsdeDateTimePicker = false

        // submit-user-db-row-form position
        const formEl = $('.submit-user-db-row-form')
        const formElTop = formEl.length ? formEl.offset().top : 0
        const formElLeft = formEl.length ? formEl.offset().left : 0
        const formElEndRight = formEl.length ? formElLeft + formEl.width() : 0
        const formElEndBottom = formEl.length ? formElTop + formEl.height() : 0

        // Check if the clicked element is inside playtime-datetime-picker elements
        const datetimePickerEls = document.querySelectorAll('.playtime-datetime-picker')
        for (const element of datetimePickerEls) {
          if (element === $event.target || element.contains($event.target)) {
            clckedInsdeDateTimePicker = true
            break
          }
        }

        // Check if outside rows content
        if (
          ((xClickedPosition >= rowContentLeft && xClickedPosition <= rowContentEndRight) && (yClickedPosition >= rowContentTop && yClickedPosition <= rowContentEndBottom)) ||
          clckedInsdeDateTimePicker
        ) {
          clickedOutsideRowContent = false
        } else {
          clickedOutsideRowContent = true
        }

        // Check if inside menu column form
        if (clickedOutsideRowContent) {
          const insideContent = (xClickedPosition >= formElLeft && xClickedPosition <= formElEndRight) && (yClickedPosition >= formElTop && yClickedPosition <= formElEndBottom)
          if (!insideContent) {
            this.selectedUserDbRow = null
            this.selectedUserDbDetails = this.filterSelectedUserDbDetails({ userDbDetails: this.selectedUserDbDetails })
            this.selectedCell = { column: null, row: null }
          }
        }
      })
    }
  },
  computed: {
    sortDraggableOptions () {
      return { animation: 250, group: 'description', disabled: false, ghostClass: 'ghost' }
    },
    ...mapGetters({
      timeFormat: 'preferredTimeFormat'
    })
  },
  beforeUnmount () {
    if (document.getElementById(SMART_TEXT_CLIPBOARD_EL_ID)) {
      document.body.removeChild(document.getElementById(SMART_TEXT_CLIPBOARD_EL_ID))
    }
  },
  mounted () {
    this.createTextareaForClipboard()
    this.triggerAutoFocusTextareaForClipboard()
    this.handleWhiteAreaClicked()

    this.isAuthenticated({
      callback: () => {
        this.setDefaultData()
        $(window).on('resize', () => { this.setDefaultData() })
      }
    })
  }
}
